import { createSlice } from '@reduxjs/toolkit'
import { constUrlBase } from 'constants/api'

export const nameMemnu: any = {
  [`${constUrlBase.bang_gia.url}`]: 'Bảng giá',
  [`${constUrlBase.phan_tich_thi_truong.url}`]: 'Phân tích thị trường',
  [`${constUrlBase.phan_tich_co_phieu.url}`]: 'Phân tích cổ phiếu',
  [`${constUrlBase.danh_muc_dau_tu.url}`]: 'Danh mục đầu tư',
}

export const MenuStore = createSlice({
  name: 'menuStore',
  initialState: {
    show: false,
    menuActive: {
      urlActive: constUrlBase.phan_tich_thi_truong.url,
      nameActive: 'Phân tích thị trường'
    },
    showNotification: false
  },
  reducers: {
    changeMenu: (state: any, action: any) => {
      state.menuActive.urlActive = action.payload?.urlActive
      state.menuActive.nameActive = nameMemnu?.[action.payload?.urlActive]
    },
    colspanMenu: (state: any) => {
      state.show = !state.show
    },
    colspanNotification: (state: any) => {
      state.showNotification = !state.showNotification
    }
  }
})

// Action creators are generated for each case reducer function
export const { colspanMenu, colspanNotification, changeMenu } = MenuStore.actions

export default MenuStore.reducer